<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="公司名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入公司名称"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入真实姓名!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="公司法人" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入公司法人姓名"
              v-decorator="[
          'legalPerson',
          {rules: [{ required: true, message: '请输入公司法人姓名!' }],initialValue:info.legalPerson}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="联系电话" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入联系电话"
              v-decorator="[
          'telephone',
          {rules: [{ required: true, message: '请输入联系电话!' }],initialValue:info.telephone}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="所属行业" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入所属行业"
              v-decorator="[
          'industry',
          {rules: [{ required: false, message: '请输入所属行业!' }],initialValue:info.industry}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="组织机构代码" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入组织机构代码"
              v-decorator="[
          'certificate',
          {rules: [{ required: false, message: '请输入组织机构代码!' }],initialValue:info.certificate}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="地区" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入地区"
              v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入地区!' }],initialValue:info.address}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="企业性质" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入企业性质"
              v-decorator="[
          'nature',
          {rules: [{ required: false, message: '请输入企业性质!' }],initialValue:info.nature}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="所属集团" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入所属集团"
              v-decorator="[
          'enterpriseGroup',
          {rules: [{ required: false, message: '请输入企业性质!' }],initialValue:info.enterpriseGroup}
        ]"
            ></a-input>
          </a-form-item>

          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <a-button type="primary" htmlType="submit">保存</a-button>
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        number: "",
        startTime: "",
        endTime: "",
        administration: "",
        company: "",
        jobTitle: "",
        address: ""
      },
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: []
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function() {
      that = this;
      this.info = this.infos;
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.info.id) {
            values.id = this.info.id;
          }

          this.isloading = true;
          this.loadingTip = "保存中...";
          this.$api.enterprise
            .saveOrUpdate(values)
            .then(res => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
                this.$emit("callbackMethod");
              } else {
                this.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },

    onRangeChange(value, dateString) {
      this.info.startTime = dateString[0];
      this.info.endTime = dateString[1];
    },
    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.scheduleBtn {
  color: #1890ff;
  cursor: pointer;
}
</style>